<template>
  <v-autocomplete
      ref="input"
      v-model="data"
      :label="label"
      :loading="loading"
      :items="items"
      v-on="$listeners"
      :rules="rules"
      item-text="name"
      item-value="id"
      :search-input.sync="searchText"
      :solo="solo"
      :clearable="clearable"
      :append-icon="appendIcon"
      :readonly="readonly"
      :disabled="disabled"
      :multiple="multiple"
      :chips="multiple"
      :small-chips="multiple"
      deletable-chips
      :placeholder="placeholder"
      @keydown="loadItems(searchText)"
      hide-details
      autocomplete="nope"
  >
  </v-autocomplete>
</template>

<script>

import OperatorRepository from "@repository/OperatorRepository";

export default {
  data(){
    return {
      loading: false,
      loaded: false,
      items: [],
      data: this.value,
      searchText: "",
    }
  },

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: [String, Array],
    role: String,
    clearable: Boolean,
    readonly: Boolean,
    isInternal: Boolean,
    disabled: Boolean,
    solo: Boolean,
    multiple: Boolean,
    rules: Array,
    appendIcon: String,
    placeholder: String,
    label: String,
  },

  watch: {

    data(val) {
      this.$emit('input', val)
      this.loadItems(null, val)
    },

    value(val) {
      this.data = val
    },

    searchText(val) {
      if(!this.loaded) {
        this.loadItems(val, this.data)
      }
    },
  },

  mounted() {
    this.loadItems(null, this.data)
  },

  computed: {

  },

  methods: {
    loadItems(searchText, defaultValue) {

      if(typeof defaultValue === "string") {
        defaultValue = [defaultValue]
      }
      this.loading = true
      OperatorRepository.search({searchText, limit: 10000, role: this.role, isInternal: this.isInternal}).then(result => {
        this.items = result.map(item => {
          return {
            id: item.id,
            name: item.name + ' (' + item.id + ')',
          }
        })
        this.loading = false
        this.loaded = true
      }).catch(err => {
        this.notifyError(err)
      })
    },

    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss">

</style>